// "aa","Afar"
// "ab","Abkhazian"
// "ae","Avestan"
// "af","Afrikaans"
// "ak","Akan"
// "am","Amharic"
// "an","Aragonese"
// "ar","Arabic"
// "as","Assamese"
// "av","Avaric"
// "ay","Aymara"
// "az","Azerbaijani"
// "ba","Bashkir"
// "be","Belarusian"
// "bg","Bulgarian"
// "bi","Bislama"
// "bm","Bambara"
// "bn","Bengali"
// "bo","Tibetan"
// "br","Breton"
// "bs","Bosnian"
// "ca","Catalan; Valencian"
// "ce","Chechen"
// "ch","Chamorro"
// "co","Corsican"
// "cr","Cree"
// "cs","Czech"
// "cu","Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic"
// "cv","Chuvash"
// "cy","Welsh"
// "da","Danish"
// "de","German"
// "dv","Divehi; Dhivehi; Maldivian"
// "dz","Dzongkha"
// "ee","Ewe"
// "el","Greek, Modern (1453-)"
// "en","English"
// "eo","Esperanto"
// "es","Spanish; Castilian"
// "et","Estonian"
// "eu","Basque"
// "fa","Persian"
// "ff","Fulah"
// "fi","Finnish"
// "fj","Fijian"
// "fo","Faroese"
// "fr","French"
// "fy","Western Frisian"
// "ga","Irish"
// "gd","Gaelic; Scottish Gaelic"
// "gl","Galician"
// "gn","Guarani"
// "gu","Gujarati"
// "gv","Manx"
// "ha","Hausa"
// "he","Hebrew"
// "hi","Hindi"
// "ho","Hiri Motu"
// "hr","Croatian"
// "ht","Haitian; Haitian Creole"
// "hu","Hungarian"
// "hy","Armenian"
// "hz","Herero"
// "ia","Interlingua (International Auxiliary Language Association)"
// "id","Indonesian"
// "ie","Interlingue; Occidental"
// "ig","Igbo"
// "ii","Sichuan Yi; Nuosu"
// "ik","Inupiaq"
// "io","Ido"
// "is","Icelandic"
// "it","Italian"
// "iu","Inuktitut"
// "ja","Japanese"
// "jv","Javanese"
// "ka","Georgian"
// "kg","Kongo"
// "ki","Kikuyu; Gikuyu"
// "kj","Kuanyama; Kwanyama"
// "kk","Kazakh"
// "kl","Kalaallisut; Greenlandic"
// "km","Central Khmer"
// "kn","Kannada"
// "ko","Korean"
// "kr","Kanuri"
// "ks","Kashmiri"
// "ku","Kurdish"
// "kv","Komi"
// "kw","Cornish"
// "ky","Kirghiz; Kyrgyz"
// "la","Latin"
// "lb","Luxembourgish; Letzeburgesch"
// "lg","Ganda"
// "li","Limburgan; Limburger; Limburgish"
// "ln","Lingala"
// "lo","Lao"
// "lt","Lithuanian"
// "lu","Luba-Katanga"
// "lv","Latvian"
// "mg","Malagasy"
// "mh","Marshallese"
// "mi","Maori"
// "mk","Macedonian"
// "ml","Malayalam"
// "mn","Mongolian"
// "mr","Marathi"
// "ms","Malay"
// "mt","Maltese"
// "my","Burmese"
// "na","Nauru"
// "nb","Bokmål, Norwegian; Norwegian Bokmål"
// "nd","Ndebele, North; North Ndebele"
// "ne","Nepali"
// "ng","Ndonga"
// "nl","Dutch; Flemish"
// "nn","Norwegian Nynorsk; Nynorsk, Norwegian"
// "no","Norwegian"
// "nr","Ndebele, South; South Ndebele"
// "nv","Navajo; Navaho"
// "ny","Chichewa; Chewa; Nyanja"
// "oc","Occitan (post 1500)"
// "oj","Ojibwa"
// "om","Oromo"
// "or","Oriya"
// "os","Ossetian; Ossetic"
// "pa","Panjabi; Punjabi"
// "pi","Pali"
// "pl","Polish"
// "ps","Pushto; Pashto"
// "pt","Portuguese"
// "qu","Quechua"
// "rm","Romansh"
// "rn","Rundi"
// "ro","Romanian; Moldavian; Moldovan"
// "ru","Russian"
// "rw","Kinyarwanda"
// "sa","Sanskrit"
// "sc","Sardinian"
// "sd","Sindhi"
// "se","Northern Sami"
// "sg","Sango"
// "si","Sinhala; Sinhalese"
// "sk","Slovak"
// "sl","Slovenian"
// "sm","Samoan"
// "sn","Shona"
// "so","Somali"
// "sq","Albanian"
// "sr","Serbian"
// "ss","Swati"
// "st","Sotho, Southern"
// "su","Sundanese"
// "sv","Swedish"
// "sw","Swahili"
// "ta","Tamil"
// "te","Telugu"
// "tg","Tajik"
// "th","Thai"
// "ti","Tigrinya"
// "tk","Turkmen"
// "tl","Tagalog"
// "tn","Tswana"
// "to","Tonga (Tonga Islands)"
// "tr","Turkish"
// "ts","Tsonga"
// "tt","Tatar"
// "tw","Twi"
// "ty","Tahitian"
// "ug","Uighur; Uyghur"
// "uk","Ukrainian"
// "ur","Urdu"
// "uz","Uzbek"
// "ve","Venda"
// "vi","Vietnamese"
// "vo","Volapük"
// "wa","Walloon"
// "wo","Wolof"
// "xh","Xhosa"
// "yi","Yiddish"
// "yo","Yoruba"
// "za","Zhuang; Chuang"
// "zh","Chinese"
// "zu","Zulu"

import { FieldTypes } from '../constants'
import { DropdownField, DropdownOptionItem } from '../types'

export const languageOptions: DropdownOptionItem[] = [
  { id: 'aa', text: 'Afar' },
  { id: 'ab', text: 'Abkhazian' },
  { id: 'ae', text: 'Avestan' },
  { id: 'af', text: 'Afrikaans' },
  { id: 'ak', text: 'Akan' },
  { id: 'am', text: 'Amharic' },
  { id: 'an', text: 'Aragonese' },
  { id: 'ar', text: 'Arabic' },
  { id: 'as', text: 'Assamese' },
  { id: 'av', text: 'Avaric' },
  { id: 'ay', text: 'Aymara' },
  { id: 'az', text: 'Azerbaijani' },
  { id: 'ba', text: 'Bashkir' },
  { id: 'be', text: 'Belarusian' },
  { id: 'bg', text: 'Bulgarian' },
  { id: 'bi', text: 'Bislama' },
  { id: 'bm', text: 'Bambara' },
  { id: 'bn', text: 'Bengali' },
  { id: 'bo', text: 'Tibetan' },
  { id: 'br', text: 'Breton' },
  { id: 'bs', text: 'Bosnian' },
  { id: 'ca', text: 'Catalan (Valencian)' },
  { id: 'ce', text: 'Chechen' },
  { id: 'ch', text: 'Chamorro' },
  { id: 'co', text: 'Corsican' },
  { id: 'cr', text: 'Cree' },
  { id: 'cs', text: 'Czech' },
  {
    id: 'cu',
    text: 'Church Slavic (Old Slavonic, Church Slavonic, Old Bulgarian)',
  },
  { id: 'cv', text: 'Chuvash' },
  { id: 'cy', text: 'Welsh' },
  { id: 'da', text: 'Danish' },
  { id: 'de', text: 'German' },
  { id: 'dv', text: 'Divehi; Dhivehi; Maldivian' },
  { id: 'dz', text: 'Dzongkha' },
  { id: 'ee', text: 'Ewe' },
  { id: 'el', text: 'Greek, Modern (1453-)' },
  { id: 'en', text: 'English' },
  { id: 'eo', text: 'Esperanto' },
  { id: 'es', text: 'Spanish (Castilian)' },
  { id: 'et', text: 'Estonian' },
  { id: 'eu', text: 'Basque' },
  { id: 'fa', text: 'Persian' },
  { id: 'ff', text: 'Fulah' },
  { id: 'fi', text: 'Finnish' },
  { id: 'fj', text: 'Fijian' },
  { id: 'fo', text: 'Faroese' },
  { id: 'fr', text: 'French' },
  { id: 'fy', text: 'Western Frisian' },
  { id: 'ga', text: 'Irish' },
  { id: 'gd', text: 'Gaelic (Scottish Gaelic)' },
  { id: 'gl', text: 'Galician' },
  { id: 'gn', text: 'Guarani' },
  { id: 'gu', text: 'Gujarati' },
  { id: 'gv', text: 'Manx' },
  { id: 'ha', text: 'Hausa' },
  { id: 'he', text: 'Hebrew' },
  { id: 'hi', text: 'Hindi' },
  { id: 'ho', text: 'Hiri Motu' },
  { id: 'hr', text: 'Croatian' },
  { id: 'ht', text: 'Haitian (Haitian Creole)' },
  { id: 'hu', text: 'Hungarian' },
  { id: 'hy', text: 'Armenian' },
  { id: 'hz', text: 'Herero' },
  { id: 'ia', text: 'Interlingua (International Auxiliary Language Association)' },
  { id: 'id', text: 'Indonesian' },
  { id: 'ie', text: 'Interlingue; Occidental' },
  { id: 'ig', text: 'Igbo' },
  { id: 'ii', text: 'Sichuan Yi; Nuosu' },
  { id: 'ik', text: 'Inupiaq' },
  { id: 'io', text: 'Ido' },
  { id: 'is', text: 'Icelandic' },
  { id: 'it', text: 'Italian' },
  { id: 'iu', text: 'Inuktitut' },
  { id: 'ja', text: 'Japanese' },
  { id: 'jv', text: 'Javanese' },
  { id: 'ka', text: 'Georgian' },
  { id: 'kg', text: 'Kongo' },
  { id: 'ki', text: 'Kikuyu (Gikuyu)' },
  { id: 'kj', text: 'Kuanyama (Kwanyama)' },
  { id: 'kk', text: 'Kazakh' },
  { id: 'kl', text: 'Kalaallisut (Greenlandic)' },
  { id: 'km', text: 'Central Khmer' },
  { id: 'kn', text: 'Kannada' },
  { id: 'ko', text: 'Korean' },
  { id: 'kr', text: 'Kanuri' },
  { id: 'ks', text: 'Kashmiri' },
  { id: 'ku', text: 'Kurdish' },
  { id: 'kv', text: 'Komi' },
  { id: 'kw', text: 'Cornish' },
  { id: 'ky', text: 'Kirghiz (Kyrgyz)' },
  { id: 'la', text: 'Latin' },
  { id: 'lb', text: 'Luxembourgish (Letzeburgesch)' },
  { id: 'lg', text: 'Ganda' },
  { id: 'li', text: 'Limburgan (Limburger, Limburgish)' },
  { id: 'ln', text: 'Lingala' },
  { id: 'lo', text: 'Lao' },
  { id: 'lt', text: 'Lithuanian' },
  { id: 'lu', text: 'Luba-Katanga' },
  { id: 'lv', text: 'Latvian' },
  { id: 'mg', text: 'Malagasy' },
  { id: 'mh', text: 'Marshallese' },
  { id: 'mi', text: 'Maori' },
  { id: 'mk', text: 'Macedonian' },
  { id: 'ml', text: 'Malayalam' },
  { id: 'mn', text: 'Mongolian' },
  { id: 'mr', text: 'Marathi' },
  { id: 'ms', text: 'Malay' },
  { id: 'mt', text: 'Maltese' },
  { id: 'my', text: 'Burmese' },
  { id: 'na', text: 'Nauru' },
  { id: 'nb', text: 'Bokmål (Norwegian, Norwegian Bokmål)' },
  { id: 'nd', text: 'Ndebele (North, North Ndebele)' },
  { id: 'ne', text: 'Nepali' },
  { id: 'ng', text: 'Ndonga' },
  { id: 'nl', text: 'Dutch (Flemish)' },
  { id: 'nn', text: 'Norwegian Nynorsk (Nynorsk, Norwegian)' },
  { id: 'no', text: 'Norwegian' },
  { id: 'nr', text: 'Ndebele (South, South Ndebele)' },
  { id: 'nv', text: 'Navajo (Navaho)' },
  { id: 'ny', text: 'Chichewa (Chewa, Nyanja)' },
  { id: 'oc', text: 'Occitan (post 1500)' },
  { id: 'oj', text: 'Ojibwa' },
  { id: 'om', text: 'Oromo' },
  { id: 'or', text: 'Oriya' },
  { id: 'os', text: 'Ossetian (Ossetic)' },
  { id: 'pa', text: 'Panjabi; Punjabi' },
  { id: 'pi', text: 'Pali' },
  { id: 'pl', text: 'Polish' },
  { id: 'ps', text: 'Pushto (Pashto)' },
  { id: 'pt', text: 'Portuguese' },
  { id: 'qu', text: 'Quechua' },
  { id: 'rm', text: 'Romansh' },
  { id: 'rn', text: 'Rundi' },
  { id: 'ro', text: 'Romanian (Moldavian, Moldovan)' },
  { id: 'ru', text: 'Russian' },
  { id: 'rw', text: 'Kinyarwanda' },
  { id: 'sa', text: 'Sanskrit' },
  { id: 'sc', text: 'Sardinian' },
  { id: 'sd', text: 'Sindhi' },
  { id: 'se', text: 'Northern Sami' },
  { id: 'sg', text: 'Sango' },
  { id: 'si', text: 'Sinhala (Sinhalese)' },
  { id: 'sk', text: 'Slovak' },
  { id: 'sl', text: 'Slovenian' },
  { id: 'sm', text: 'Samoan' },
  { id: 'sn', text: 'Shona' },
  { id: 'so', text: 'Somali' },
  { id: 'sq', text: 'Albanian' },
  { id: 'sr', text: 'Serbian' },
  { id: 'ss', text: 'Swati' },
  { id: 'st', text: 'Sotho, Southern' },
  { id: 'su', text: 'Sundanese' },
  { id: 'sv', text: 'Swedish' },
  { id: 'sw', text: 'Swahili' },
  { id: 'ta', text: 'Tamil' },
  { id: 'te', text: 'Telugu' },
  { id: 'tg', text: 'Tajik' },
  { id: 'th', text: 'Thai' },
  { id: 'ti', text: 'Tigrinya' },
  { id: 'tk', text: 'Turkmen' },
  { id: 'tl', text: 'Tagalog' },
  { id: 'tn', text: 'Tswana' },
  { id: 'to', text: 'Tonga (Tonga Islands)' },
  { id: 'tr', text: 'Turkish' },
  { id: 'ts', text: 'Tsonga' },
  { id: 'tt', text: 'Tatar' },
  { id: 'tw', text: 'Twi' },
  { id: 'ty', text: 'Tahitian' },
  { id: 'ug', text: 'Uighur (Uyghur)' },
  { id: 'uk', text: 'Ukrainian' },
  { id: 'ur', text: 'Urdu' },
  { id: 'uz', text: 'Uzbek' },
  { id: 've', text: 'Venda' },
  { id: 'vi', text: 'Vietnamese' },
  { id: 'vo', text: 'Volapük' },
  { id: 'wa', text: 'Walloon' },
  { id: 'wo', text: 'Wolof' },
  { id: 'xh', text: 'Xhosa' },
  { id: 'yi', text: 'Yiddish' },
  { id: 'yo', text: 'Yoruba' },
  { id: 'za', text: 'Zhuang (Chuang)' },
  { id: 'zh', text: 'Chinese' },
  { id: 'zu', text: 'Zulu' },
]

export const languageField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Language',
  searchable: true,
  options: languageOptions,
}
